import React from 'react';
import {Flex, Arrow} from '/app/src/component';
import style from './style.css';
import PropTypes from 'prop-types';

class SelectInput extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            select: props.select,
        }
        this.onChange = this.onChange.bind(this)
    }

    componentDidUpdate(prevProps){
        if(this.props.select !== prevProps.select){
            this.setState({
                select: this.props.select
            })
        }
    }

    onChange(e){
        e.target.name = this.props.name
        this.props.onChange(e)
        this.setState({
            select: e.target.value
        })
    }
    _renderList(values){
        var selects = []
        for(var value in values){
            selects.push(<option value={value} key={value}> {values[value]} </option>)
        }
        return selects
    }

    render() {
        const values = this.props.values;
        return(
            <Flex className={style.SelectWrapper+ ' '+this.props.className} width={this.props.width} shrink={0} center>
                <select value={this.state.select} onChange={this.onChange} disabled={this.props.disabled} style={{width: '100%', paddingRight: '40px'}}>
                    {this._renderList(values)}
                </select>
                <Flex className={style.Arrow} center shrink={0}>
                    <Arrow direction='down' color='grey' size='small'/>
                </Flex>
            </Flex>
        );
    }
}
/**
 * @select: Initial value of the select input
 * @onChange: When the select input change the selected field
 * @values: Value object e.g. values={{admin: Admin, manager: Manager}}
 */
SelectInput.propTypes = {
    onChange: PropTypes.func,
    values: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ])
  };

export default SelectInput;



// WEBPACK FOOTER //
// ./src/component/Forms/SelectInput/index.js